import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Administrator} from '../../../administrators/models';
import {Observable} from 'rxjs';
import {Order} from '../../models';
import {Store} from '@ngrx/store';
import {ApplicationState} from '../../../application-state/store';
import {AdministratorsSelectors} from '../../../administrators/store/selectors';
import {loadIfNotLoaded} from '../../../shared/utilities/observable.utility';
import {AdministratorsActions} from '../../../administrators/store';
import {OrdersSelectors} from '../../store/selectors';

@Component({
  selector: 'app-order-technician-select',
  styleUrls: ['./order-technician-select.component.scss'],
  template: `
    <div [formGroup]="formGroup">
      <ng-select
        [items]="items$|async"
        bindLabel="name"
        [searchable]="true"
        [loading]="isLoading$| async"
        bindValue="@id"
        [clearable]="true"
        [searchFn]="findItem"
        placeholder="Techniker"
        [formControlName]="fieldName"
        (change)="setSelectedItem($event)">

        <ng-template ng-label-tmp let-item="item">
          {{item.firstName}} {{item.lastName}}
          <span *ngIf="getOrderCount(item['@id'])>0">({{getOrderCount(item['@id'])}}x)</span>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          {{item.firstName}} {{item.lastName}}
          <span *ngIf="getOrderCount(item['@id'])>0">({{getOrderCount(item['@id'])}}x)</span>

        </ng-template>
      </ng-select>
    </div>
  `

})
export class OrderTechnicianSelectComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() fieldName: string;
  @Output() updateSelectedObject: EventEmitter<Administrator> = new EventEmitter<Administrator>();

  items$: Observable<Array<Administrator>>;
  isLoading$: Observable<boolean>;
  selectedItem: Administrator;
  orders: Order[];

  constructor(private store$: Store<ApplicationState>) {
  }

  ngOnInit(): void {
    this.items$ = this.store$.select(AdministratorsSelectors.sList);
    this.isLoading$ = this.store$.select(AdministratorsSelectors.isLoading);
    loadIfNotLoaded(this.store$, AdministratorsSelectors.isLoaded, AdministratorsActions.ReadAdministrators());
    this.store$.select(OrdersSelectors.sList).subscribe((orders) => {
      this.orders = orders;
    });

  }

  getOrderCount(adminIri: string): number {
    return this.orders.filter(e => e.technician === adminIri).length || -1;
  }

  setSelectedItem(element: Administrator): void {
    this.selectedItem = element;
    this.updateSelectedObject.emit(element);
  }

  findItem(term: string, item: Administrator): boolean {
    const parts = term.split(' ');
    return parts.every(t => {
      return (item.firstName.toLowerCase().indexOf(t.toLowerCase()) > -1) ||
        (item.lastName && item.lastName.toLowerCase().indexOf(t.toLowerCase()) > -1) ||
        (item.middleName && item.middleName.toLowerCase().indexOf(t.toLowerCase()) > -1);
    });
  }


}
